import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import HomePage from "./pages/HomePage";
import KakaoAuthPage from "./pages/KakaoAuthPage";
import NotFoundPage from "./pages/NotFoundPage";
import { ROUTE_PATH } from "./constants";
import PolicyAgreePage from "./pages/PolicyAgreePage";
import RoomPage from "./pages/RoomPage";
import PaymentPage from "./pages/PaymentPage";
import CheckOutPage from "./pages/CheckOutPage";
import BookingPage from "./pages/BookingPage";

const { BOOKING, AUTH, POLICY_AGREE, ROOM, PAYMENT, CHECKOUT } = ROUTE_PATH;

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    errorElement: <NotFoundPage />,
    children: [
      { index: true, element: <HomePage /> },
      { path: BOOKING, element: <BookingPage /> },
      { path: POLICY_AGREE, element: <PolicyAgreePage /> },
      { path: AUTH, element: <KakaoAuthPage /> },
      { path: ROOM, element: <RoomPage /> },
      { path: PAYMENT, element: <PaymentPage /> },
      { path: CHECKOUT, element: <CheckOutPage /> },
    ],
  },
]);

export default router;
